import { ILead, ILeadDetail } from '@user/store/lead'

export enum LEAD_STATUSES {
  Qualify = 'qualify',
  Disqualified = 'disqualified',
  Open = 'open',
}

export type LeadStatus =
  | LEAD_STATUSES.Disqualified
  | LEAD_STATUSES.Open
  | LEAD_STATUSES.Qualify

type LeadPermissionFlags = {
  canUpdate: boolean
  canDelete: boolean
  canConvert: boolean
}

export type LeadCardProps = LeadPermissionFlags & {
  lead: ILead
  hasScheduledAppointment: boolean
}

export type LeadParentHeaderProps = LeadPermissionFlags & {
  detailPage?: boolean
  lead: ILead | ILeadDetail
}
